const state = {
  document: {
    id: null,
    name: null
  },
  documents: [],
  dataToPersist: null,
  processPath: null
}

const getters = {
  documentsCreated (state) {
    return state.documents.length ? state.documents : null
  },
  lastDocumentCreated (state) {
    return state.document.id ? state.document : null
  },
  dataToPersist (state) {
    return state.dataToPersist
  },
  processPathToGoBack (state) {
    return state.processPath
  }
}

const mutations = {
  setDocument (state, payload) {
    state.document = payload
    state.documents.push(payload)
  },
  setDataToPersist (state, payload) {
    state.dataToPersist = payload
  },
  setProcessPath (state, payload) {
    state.processPath = payload
  },
  clearProcessesStore (state) {
    state.document.id = null
    state.document.name = null
    state.documents = []
    state.dataToPersist = null
    state.processPath = null
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
